{
  "AdmittedBusinesses": "Tekne opp i inkubasjonsprogrammet i løpet av året",
  "AdvicedAccessToOtherTools": "Har de bistått bedrifta i prosessar med å få tilgang til andre verkemiddel i år?",
  "BusinessDigitalCompetence": "Deltek i kompetanseheving innanfor digitalisering",
  "BusinessesAdvicedFromOthers": "Får råd frå andre programoperatørar",
  "BusinessesInOtherPrograms": "Tekne opp i program hjå andre programoperatørar",
  "BusinessesReferredToOthers": "Viste til andre programoperatørar",
  "CompetenceProjectsWithOthers": "Gjennomført nettverksprosjekt saman med andre programoperatørar",
  "CooperatingBusinesses": "",
  "DigitalCompetenceEmployees": "Tilsette har delteke på kompetanseheving innanfor digitalisering",
  "DigitalizationInBusinessPlan": "Har digitalisering som eit sentralt element i forretningsmodellen",
  "ExportCompetenceBuilding": "Tilbyr kompetanseheving innanfor eksport",
  "ExportTurnover": "Heile eller delar av omsetninga består av eksport?",
  "FemaleLeadership": "Har bedriften kvinneleg gründer og/eller kvinneleg dagleg leiar og/eller kvinneleg styreformann?",
  "InternationalCooperation": "Har bedrifta blitt koblet opp mot internasjonal aktør?",
  "InternationalMarket": "Har bedrifta internasjonalt marked?",
  "NewBusinesses": "Nyetablert",
  "NewIdeas": "Har ny idé",
  "OtherBusinessesAdviced": "Får rådgiving",
  "PaidEquity": "Egenkapital som er innbetalt til bedriften i løpet av året (oppgis i absolutte tall)",
  "SRLScaleIncrease": "Kva nivå i SRL-skalaen plasserer bedrifta på?",
  "SupportedBusinesses": "Innovasjonsstøtte",
  "SustainabilityBusinesses": "Får kompetanseheving innanfor berekraft",
  "SustainabilityEmployees": "Kompetanseheving innanfor berekraft som tilsette i inkubatoren/næringsparken har delteke på i løpet av året",
  "SustainabilityInBusinessModel": "Har berekraft som eit sentralt element i si forretningsmodell",
  "TaxonomyQuestions": "Har bedrifta (potensielt) vesentleg positiv eller negativ effekt på nokon av miljømåla?"
}
